// KuntoTable row labels per main category.
// These populate the Yhteenveto table when a new subsection is added.
export const CATEGORY_KUNTO_ROWS = {
  Julkisivut: [
    "Julkisivuelementit",
    "Elementtisaumat",
    "Pinnoitteet",
    "Vesipellit",
    "Sokkelit",
    "Sokkelipinnat",
  ],

  Parvekkeet: [
    "Parvekelaatta",
    "Parvekelaatan kallistus",
    "Parvekelaatan vesieristys",
    "Veden poisto",
    "Parvekekaide",
    "Pielirakenteet",
  ],

  Ikkunat: [
    "Ulkopuite",
    "Ulkopuitteen kynteet",
    "Tiivistykset rakenteisiin",
    "Vesipellit",
    "Saranat",
    "Avaussuunta",
    "Sulkijat",
    "Alakarmi",
    "Nousukiilat",
    "Veden poisto",
    "Sisäpuite ja ikkunavälit",
    "Helat",
    "Tiivisteet",
  ],

  Ovet: [
    "Ulkolehti ja pinnat",
    "Ulkopuitteen kynteet",
    "Tiivistykset rakenteisiin",
    "Vesipellit",
    "Saranat",
    "Kynnys",
    "Sisäpinnat",
    "Helat",
    "Tiivisteet",
  ],
  Ryömintätilat: [
    "Alapohjan kantava rakenne",
    "Käyntiluukut",
    "Eristeet",
    "Läpiviennit",
    "Ryömintätilan tuuletus",
    "Ryömintätilan korkeus",
    "Maapohja",
    "Vastapenkat",
    "Putkikannakkeet",
  ],

  Vesikatot: [
  "Vesikate",
  "Aluskate",
  "Läpiviennit",
  "Pellitykset",
  "Kattoturvatuotteet",
  "Sadevesijärjestelmä",
  "Yläpohja",
  "Yläpohjan eristeet",
  "Putkieristeet",
  "Palokatkot",
],
};
